enum CustomFieldParentType {
  USER = "USER",
  CARD = "CARD",
  TRANSACTION = "TRANSACTION",
  INVOICE = "INVOICE",
  PAYMENT = "PAYMENT",
  CONTACT = "CONTACT",
  REIMBURSEMENT = "REIMBURSEMENT",
}

export default CustomFieldParentType;
